import { lazy, Suspense } from "react";

export type AiCharacterMode = "idle" | "thinking" | "talking";

type AiCharacterRivProps = {
  mode: AiCharacterMode;
  /** Tailwind size classes, like VideoPlayerRiv. */
  width?: string;
  height?: string;
  className?: string;
};

// Same lazy pattern as VideoPlayerRiv: the @rive-app/react-canvas runtime
// only loads when the character actually renders.
const AiCharacterRivLazy = lazy(() =>
  import("./AiCharacterRivInner").then((mod) => ({ default: mod.AiCharacterRivInner })),
);

export const AiCharacterRiv: React.FC<AiCharacterRivProps> = ({
  mode,
  width = "w-8",
  height = "h-8",
  className = "",
}) => {
  return (
    <div className={`${width} ${height} ${className}`} aria-hidden>
      <Suspense fallback={null}>
        <AiCharacterRivLazy mode={mode} />
      </Suspense>
    </div>
  );
};
